// Draws the centre benchmark sections a public page embeds (the CRE industry page): each
// [data-centre-benchmark] container carries its section's numbers as inline JSON
// (IndustriesHelper#cre_benchmark_chart, from the run's site.json: shares, ratios and counts) and
// is drawn by the benchmark report's own code (db/data/centres/page/sections.js), so the page and
// the report show the same chart. That code is import()ed into a split chunk when a chart first
// nears the viewport, like the trends scatter's Vega. The colour tokens live on the section's
// .cb block, scoped away from the rest of the page.
import { whenVisible } from "./lazy"

export function initCentreBenchmarks() {
  document.querySelectorAll("[data-centre-benchmark]").forEach((el) => {
    whenVisible(el, () => mount(el).catch(() => {}))
  })
}

async function mount(el) {
  const { CB, setTokenRoot } = await import("../../../db/data/centres/page/sections.js")
  const script = el.querySelector("script[type='application/json']")
  if (!script) return

  const data = JSON.parse(script.textContent)
  const options = el.dataset.options ? JSON.parse(el.dataset.options) : {}
  setTokenRoot(el.closest(".cb"))
  el.replaceChildren()
  CB.draw(el.dataset.centreBenchmark, el, data, options)
  // A paragraph the page sets between a section's charts and its table follows the container in
  // the HTML (data-benchmark-before-table names the section), so it reads without JS; it moves in
  // here once the section is drawn.
  const inset = el.parentElement.querySelector(`[data-benchmark-before-table="${el.dataset.centreBenchmark}"]`)
  const table = el.querySelector(":scope > .tbl-wrap")
  if (inset && table) el.insertBefore(inset, table)
}
